

import { Component, Prop, Vue } from "vue-property-decorator"

@Component
export default class CdnEventNotifications extends Vue {
    @Prop()
    mobile!: boolean

    show: boolean = false
    timeout: number = 10000
    icon: string = "notifications"
    to: string = "/notifications"
    message: string = ""
    me: any = {}

    beforeMount() {
        if (!this.iosWrapperClient())
            return
        (window as { [key: string]: any })['showInAppNotification'] = this.showInAppNotification
    }

    showInAppNotification(payload: any) {
        try {
            if (this.show) return false
            payload = JSON.parse(payload)
            const alert: any = payload.aps.alert
            const message: string = alert.body
            this.message = message
            if ('data' in payload) {
                try {
                    const data: any = payload.data
                    const type: string = data.type
                    const uuid: string = data.referenceUuid
                    if (type && uuid)
                        this.to = `${type}/${uuid}`
                    this.icon = this.iconByType(type)
                } catch (e) {
                    console.error("could not extract re-route information from push notification payload", e)
                }
            }
            this.show = true
            return true
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    go() {
        this.show = false
        this.$router.push(this.to)
    }

    iconByType(type: string): string {
        switch (type) {
            case "job": return "work"
            default:    return "notifications"
        }
    }

    get inhibitSubscription() {
        return localStorage && !!localStorage.getItem("inhibitSubscription")
    }

    iosWrapperClient() {
        return Vue.prototype.$iosWrapperClient
    }
}
